import React,{useEffect, useState, useCallback} from 'react'
import { Link } from 'react-router-dom'
import { Card,Button, Row, Col, Container, Modal } from 'react-bootstrap';
const Questions = ({location}) =>{
    
    const [contestId,setContestId] = useState()
    const [questionsData, setQuestionsData] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [validData, setValidData] = useState(false)    
    const [errors,setErrors] = useState(false)
    const [questionName, setQuestionName] = useState("")
    const [loader, setLoader] = useState(true)
    const modalHandler = () =>{
        setShowModal(!showModal)
    }


      

    const loadData = useCallback(async () =>{
        setLoader(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UCI")
        setContestId(temp2)
        const response = await fetch(`https://codezap-e156b.firebaseio.com/contests/${temp2}.json`)
        const resData = await response.json()
        var arr = []
        
        if(resData){
        if(resData["questions"]){
            setValidData(true)
            arr = Object.keys(resData["questions"])
        }}
        
            
        setQuestionsData(arr)
        
        setLoader(false)
        
    },[location.search])
    
    // function makeid(length) {
    //     var result           = '';
    //     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //     var charactersLength = characters.length;
    //     for ( var i = 0; i < length; i++ ) {
    //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
    //     }
    //     return result;
    // }

    useEffect(() =>{
        
        loadData()
        
    },[loadData])
    
    const createQuestionHandler = async() =>{
        
        if(questionName !== "" ){
           
          setShowModal(false)
        }
        else{
            setErrors(true)
        }
    }
    
    return(
        <section className = "hero">
            <header className="mb-4 shadow">
                <nav className="navbar navbar-dark bg-dark primary-styled-border">
                    <div className="container">
                        <Link to = "/" style = {{color:"white"}}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style = {{fontSize:"40px"}}></i>
                        </Link>
                        
                        <div>
                        
                        
                        {loader ? <p></p>:<h1 style = {{color:"white"}}> {contestId.split("_").join(" ").substring(0, contestId.split("_").join(" ").length - 4)}</h1>}
                        </div>
                    </div>
                </nav>
            </header> 
            {loader ? <p></p>:
            <Container style = {{marginTop:"3%"}}>
            <h1>{contestId.split("_").join(" ").substring(0, contestId.split("_").join(" ").length - 4)}</h1>
            <Row>
                
            { validData ?
                questionsData.map(item => 
                    <Col key = {item} style = {{marginTop:"3%"}}>
                        <Card style={{ width: '18rem' }}>
                            
                            <Card.Body>
                                <Card.Title>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                <br/>
                                <Row>
                                    <Link to = 
                                        {'/editQuestion?UQI='+item+"@"+contestId}
                                    >
                                        <Button variant="primary" style = {{margin:"1.5%"}}>Edit Question</Button>
                                        
                                    </Link>
                                    <Button variant="danger" style = {{width:"49%",margin:"1%"}}>Delete</Button>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    ):
                    <p></p>
            }
            
            
            </Row>
            <button className = "btn btn-success" id="add" onClick = {modalHandler}   style = {{width:"20%",margin:"0.5% 2%",marginLeft:"71%"}}>Add Question</button>  
            <Link to = {"/leaderboardadmin?UCI="+contestId} >
            <button className = "btn btn-info" id="leaderboard"  style = {{width:"20%",margin:"0.5% 2%",marginLeft:"71%"}}>Leaderboard</button>  
            </Link>
            <Modal show = {showModal} onHide = {modalHandler}>
                    <Modal.Header closeButton><h3>Create Question</h3></Modal.Header>
                    <Modal.Body>
                    {errors ? <p>Submit form correctly</p> : <p></p>}
                    <p style = {{color:"#979faf",fontStyle:"italic"}}>Get started by providing the initial details for your question.</p><br/>
                    <label style = {{fontWeight:"bold"}}>Question Name<span style = {{color:"#f65039"}}>*</span></label>
                    <input
                        className = "inputM"
                        type = "text" 
                        autoFocus 
                        required 
                        value = {questionName} 
                        onChange = {(e) => setQuestionName(e.target.value)}
                    /> 
                    <br/><br/>
                    </Modal.Body>
                    <Modal.Footer>
                    <button className = "btn btn-success" id="closeModal" onClick = {createQuestionHandler}  style = {{width:"20%",margin:"2%",marginLeft:"71%"}}>Submit</button>  
                    </Modal.Footer>
            </Modal>
            </Container>
            }
            
        </section>
    )
}

export default Questions